//#region Imports
import React, { useState, useEffect, useRef } from "react";
import { StyleSheet, Platform, SafeAreaView } from "react-native";
import { useTheme } from "@react-navigation/native";
import { useAccountContext } from "../../hooks/useAccountContext";
import { useTraining } from "../../hooks/useTraining";
import MyTrainingsDetailsScreen from "../SelfService/Trainings/MyTrainingsDetailsScreen";
// * Language
import { useTranslation } from "react-i18next";
import MyTrainingsScreen from "../SelfService/Trainings/MyTrainingsScreen";
//#endregion

const HomePageMyTrainings = ({ route }) => {
  //#region Const Definitions
  const { colors } = useTheme();
  const styles = makeStyles(colors);
  const { account } = useAccountContext();
  const { t } = useTranslation();
  const { loadUserTrainings, loadTrainingFromUI, loadTrainingHelpers } = useTraining();

  /* All screens related to timesheets */
  const showMyTrainingsScreenRef = useRef(null);
  const [showMyTrainingsDetailsScreen, setShowMyTrainingsDetailsScreen] = useState(0);
  const [showMyTrainingsScreen, setShowMyTrainingsScreen] = useState(1);

  /* Data kept and passed to screens */
  const [userTrainingsList, setUserTrainingsList] = useState([]);
  const [trnUI, setTRNUI] = useState(null);
  const [trnInfo, setTRNInfo] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [isNew, setIsNew] = useState(false);
  const [isUserEditable, setIsUserEditable] = useState(true);

  // Helper for dropdowns variables
  const [ldNeed, setLDNeed] = useState([]);
  const [ldMethod, setLDMethod] = useState([]);
  const [trnProvider, setTRNProvider] = useState([]);

  //#region SelectScreens
  const selectMyTrainingsScreen = () => {
    setShowMyTrainingsScreen(1);
    setShowMyTrainingsDetailsScreen(0);
  };

  const selectMyTrainingsDetailsScreen = () => {
    setShowMyTrainingsScreen(0);
    setShowMyTrainingsDetailsScreen(1);
  };
  //#endregion

  // #region Load Data
  const loadTSHelper = () => {
    if (account) {
      loadTrainingHelpers()
        .then((userData) => {
          setLDNeed(userData.ldNeed)
          setLDMethod(userData.ldMethod)
          setTRNProvider(userData.trainingProvider)
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const loadUserTRN = () => {
    if (account) {
      loadUserTrainings(account.employeeId)
        .then((userData) => {
          setUserTrainingsList(userData);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const loadTRNDetails = () => {
    if (account) {
      loadTrainingFromUI(trnUI)
        .then((userData) => {
          setIsEdit(userData[0].accepted || !userData[0].userEditable ? false : true);
          setIsUserEditable(userData[0].accepted ? true : userData[0].userEditable);
          setTRNInfo(userData)
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  //#endregion

  //#region UseEffect
  useEffect(() => {
    showMyTrainingsScreenRef.current = showMyTrainingsScreen;
  }, [showMyTrainingsScreen]);

  useEffect(() => {
    loadTSHelper();
    loadUserTRN();
  }, [])

  useEffect(() => {
    if (trnUI !== null)
      loadTRNDetails();
  }, [trnUI])

  // Handles refresh in web
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem("showMyTrainingsScreen", showMyTrainingsScreenRef.current);
        localStorage.setItem('isRefresh', "true");
        localStorage.setItem('lastVisitedScreen', 'HomePageMyTrainings');
      } catch (error) {
        console.log(error.message);
      };
    };

    if (Platform.OS === 'web') {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    };
  }, []);

  const checkIfRefreshed = () => {
    try {
      const isRefresh = localStorage.getItem("isRefresh");
      if (isRefresh === "true") {
        localStorage.setItem("isRefresh", "false");
        const savedScreen = parseInt(localStorage.getItem("showMyTrainingsScreen"));
        setShowMyTrainingsScreen(isNaN(savedScreen) ? 1 : savedScreen);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (Platform.OS === "web") {
      checkIfRefreshed();
    }
    setShowMyTrainingsScreen(1);
  }, []);
  //#endregion

  return (
    <SafeAreaView style={styles.rowMain}>
      <SafeAreaView style={styles.main}>
        {showMyTrainingsScreen ? (
          <MyTrainingsScreen
            userTrainings={userTrainingsList}
            setTRNUI={setTRNUI}
            setIsNew={setIsNew}
            selectMyTrainingsDetailsScreen={selectMyTrainingsDetailsScreen}
          />
        ) : (
          <></>
        )}

        {showMyTrainingsDetailsScreen ? (
          <MyTrainingsDetailsScreen
            trnInfo={trnInfo}
            ldMethod={ldMethod}
            trnUI={trnUI}
            ldNeed={ldNeed}
            trnProvider={trnProvider}
            isEdit={isNew ? true : isEdit}
            isUserEditable={isNew ? true : isUserEditable}
            setIsNew={setIsNew}
            isNew={isNew}
            loadTRNDetails={loadTRNDetails}
            loadUserTRN={loadUserTRN}
            selectMyTrainingsScreen={selectMyTrainingsScreen}
          />
        ) : (
          <></>
        )}
      </SafeAreaView>
    </SafeAreaView >
  )
};

const makeStyles = (colors) =>
  StyleSheet.create({
    main: {
      flex: 1,
      marginTop: 20,
    },
    rowMain: {
      flex: 1,
      flexDirection: 'row',
    },
  });

export default HomePageMyTrainings;